// A collection of enum, each of data-testid for different pages
export var AdminPageSidebarTestId;
(function (AdminPageSidebarTestId) {
    AdminPageSidebarTestId["AdminPageSideBar"] = "AdminPageSideBar";
    AdminPageSidebarTestId["AdminPageSideBarMenuItem"] = "AdminPageSideBarMenuItem";
    AdminPageSidebarTestId["TeamAccountSelector"] = "TeamAccountSelector";
})(AdminPageSidebarTestId || (AdminPageSidebarTestId = {}));
export var RedirectToContainer = 'RedirectToContainer';
export var BudgetPageTestId;
(function (BudgetPageTestId) {
    BudgetPageTestId["BudgetListNoBudgetText"] = "BudgetListNoBudgetText";
    BudgetPageTestId["BudgetListContainer"] = "BudgetListContainer";
    BudgetPageTestId["BudgetCell"] = "BudgetCell";
    BudgetPageTestId["BudgetDetail"] = "BudgetDetail";
    BudgetPageTestId["BudgetDetailTitle"] = "BudgetDetailTitle";
    BudgetPageTestId["BudgetRestrictionInfo"] = "BudgetRestrictionInfo";
    BudgetPageTestId["BudgetListBudgetTypeSummary"] = "BudgetListBudgetTypeSummary";
    BudgetPageTestId["BudgetListBudgetActiveDates"] = "BudgetListBudgetActiveDates";
    BudgetPageTestId["BudgetListBudgetType"] = "BudgetListBudgetType";
    BudgetPageTestId["BudgetListViewMore"] = "BudgetCellViewMore";
})(BudgetPageTestId || (BudgetPageTestId = {}));
export var PageNotFoundTestId;
(function (PageNotFoundTestId) {
    PageNotFoundTestId["PageNotFoundContainer"] = "PageNotFoundContainer";
})(PageNotFoundTestId || (PageNotFoundTestId = {}));
export var BootstrapContainerTestId;
(function (BootstrapContainerTestId) {
    BootstrapContainerTestId["LoadingSpinner"] = "BootstrapLoadingSpinner";
    BootstrapContainerTestId["RedirectLoadingSpinner"] = "BootstrapRedirectLoadingSpinner";
})(BootstrapContainerTestId || (BootstrapContainerTestId = {}));
export var MembersPageTestId;
(function (MembersPageTestId) {
    MembersPageTestId["AddMembersButton"] = "AddMembersButton";
    MembersPageTestId["SearchField"] = "SearchField";
    MembersPageTestId["GrantAdminAccess"] = "GrantAdminAccess";
    MembersPageTestId["RevokeAdminAccess"] = "RevokeAdminAccess";
    MembersPageTestId["RemoveEmployee"] = "RemoveEmployee";
    MembersPageTestId["MembersMenuButton"] = "MembersMenuButton";
    MembersPageTestId["ResendIndividualJoinInvite"] = "ResendIndividualJoinInvite";
})(MembersPageTestId || (MembersPageTestId = {}));
export var AddMembersModalTestId;
(function (AddMembersModalTestId) {
    AddMembersModalTestId["AddMembersSubmitButton"] = "AddMembersSubmitButton";
    AddMembersModalTestId["AddMembersCancelButton"] = "AddMembersCancelButton";
    AddMembersModalTestId["AddMembersLimitBanner"] = "AddMembersLimitBanner";
    AddMembersModalTestId["AddMembersInviteToTeamError"] = "AddMembersInviteToTeamError";
})(AddMembersModalTestId || (AddMembersModalTestId = {}));
export var RemoveMemberModalTestId;
(function (RemoveMemberModalTestId) {
    RemoveMemberModalTestId["RemoveMemberSubmitButton"] = "RemoveMemberSubmitButton";
    RemoveMemberModalTestId["RemoveMemberCancelButton"] = "RemoveMemberCancelButton";
})(RemoveMemberModalTestId || (RemoveMemberModalTestId = {}));
export var GroupPageTestId;
(function (GroupPageTestId) {
    GroupPageTestId["CreateNewGroupButton"] = "CreateNewGroupButton";
    GroupPageTestId["GroupAddMembers"] = "GroupAddMembers";
    GroupPageTestId["EditGroup"] = "EditGroup";
    GroupPageTestId["DeleteGroup"] = "DeleteGroup";
    GroupPageTestId["GroupMenuButton"] = "GroupMenuButton";
    GroupPageTestId["GroupListItem"] = "GroupListItem";
})(GroupPageTestId || (GroupPageTestId = {}));
export var GroupModalTestId;
(function (GroupModalTestId) {
    GroupModalTestId["CreateGroupSubmitButton"] = "CreateGroupSubmitButton";
    GroupModalTestId["CreateGroupCancelButton"] = "CreateGroupCancelButton";
    GroupModalTestId["EditGroupSubmitButton"] = "EditGroupSubmitButton";
})(GroupModalTestId || (GroupModalTestId = {}));
export var DeleteGroupModalTestId;
(function (DeleteGroupModalTestId) {
    DeleteGroupModalTestId["DeleteGroupSubmitButton"] = "DeleteGroupSubmitButton";
    DeleteGroupModalTestId["DeleteGroupCancelButton"] = "DeleteGroupCancelButton";
})(DeleteGroupModalTestId || (DeleteGroupModalTestId = {}));
export var GroupMembersPageTestId;
(function (GroupMembersPageTestId) {
    GroupMembersPageTestId["GroupMembersPageAddMembersButton"] = "GroupMembersPageAddMembersButton";
    GroupMembersPageTestId["GroupMembersPageDeleteMember"] = "GroupMembersPageDeleteMember";
    GroupMembersPageTestId["GroupMembersPageMenuButton"] = "GroupMembersPageMenuButton";
    GroupMembersPageTestId["GroupMembersPageBackButton"] = "GroupMembersPageBackButton";
})(GroupMembersPageTestId || (GroupMembersPageTestId = {}));
export var OrderHistoryPageTestId;
(function (OrderHistoryPageTestId) {
    OrderHistoryPageTestId["DownloadOrderHistoryButton"] = "DownloadOrderHistoryButton";
    OrderHistoryPageTestId["DownloadFileDropdownEM"] = "DownloadFileDropdownEM";
    OrderHistoryPageTestId["DownloadFileDropdownDP"] = "DownloadFileDropdownDP";
})(OrderHistoryPageTestId || (OrderHistoryPageTestId = {}));
export var HeaderTestId;
(function (HeaderTestId) {
    HeaderTestId["SupportButton"] = "SupportButton";
    HeaderTestId["ProfileMenuButton"] = "ProfileMenuButton";
    HeaderTestId["TermsButton"] = "TermsButton";
    HeaderTestId["LogoutButton"] = "LogoutButton";
})(HeaderTestId || (HeaderTestId = {}));
export var ExpensedMealsUpsellPage;
(function (ExpensedMealsUpsellPage) {
    ExpensedMealsUpsellPage["ExpensedMealsUpsellPageLearnMore"] = "ExpensedMealsUpsellPageLearnMore";
})(ExpensedMealsUpsellPage || (ExpensedMealsUpsellPage = {}));
export var DashpassUpsellPage;
(function (DashpassUpsellPage) {
    DashpassUpsellPage["DashpassUpsellPageLearnMore"] = "DashpassUpsellPageLearnMore";
})(DashpassUpsellPage || (DashpassUpsellPage = {}));
export var DashpassSubscribedPage;
(function (DashpassSubscribedPage) {
    DashpassSubscribedPage["DashpassSubscribedPageGetHelp"] = "DashpassSubscribedPageGetHelp";
})(DashpassSubscribedPage || (DashpassSubscribedPage = {}));
export var BudgetsPageTestId;
(function (BudgetsPageTestId) {
    BudgetsPageTestId["CreateBudgetButton"] = "CreateBudgetButton";
})(BudgetsPageTestId || (BudgetsPageTestId = {}));
export var BudgetModalTestId;
(function (BudgetModalTestId) {
    BudgetModalTestId["BudgetSaveButton"] = "BudgetSaveButton";
    BudgetModalTestId["BudgetDetailsSectionButton"] = "BudgetDetailsSectionButton";
    BudgetModalTestId["OrderRestrictionsSectionButton"] = "OrderRestrictionsSectionButton";
    BudgetModalTestId["ExpenseCodesSectionButton"] = "ExpenseCodesSectionButton";
    BudgetModalTestId["BudgetTypeSelector"] = "BudgetTypeSelector";
    BudgetModalTestId["DaysSelector"] = "DaysSelector";
    BudgetModalTestId["TimesSelector"] = "TimesSelector";
    BudgetModalTestId["ConvenienceGroceryCheckBox"] = "ConvenienceGroceryCheckBox";
    BudgetModalTestId["AlcoholCheckBox"] = "AlcoholCheckBox";
    BudgetModalTestId["ExpenseCodeToggle"] = "ExpenseCodeToggle";
    BudgetModalTestId["ExpenseCodeSelector"] = "ExpenseCodeSelector";
    BudgetModalTestId["RetailCheckBox"] = "RetailCheckBox";
})(BudgetModalTestId || (BudgetModalTestId = {}));
export var TeamAccountMemberLimitReachedTestId;
(function (TeamAccountMemberLimitReachedTestId) {
    TeamAccountMemberLimitReachedTestId["Banner"] = "TeamAccountMemberLimitReachedTestBanner";
})(TeamAccountMemberLimitReachedTestId || (TeamAccountMemberLimitReachedTestId = {}));
export var OptInTestId;
(function (OptInTestId) {
    OptInTestId["EnrollEmailField"] = "EnrollEmailField";
    OptInTestId["EnrollButton"] = "EnrollButton";
})(OptInTestId || (OptInTestId = {}));
export var BudgetFormV2TestId;
(function (BudgetFormV2TestId) {
    BudgetFormV2TestId["BudgetTypeSelector"] = "BudgetTypeSelector";
    BudgetFormV2TestId["BudgetFrequencySelector"] = "BudgetFrequencySelector";
})(BudgetFormV2TestId || (BudgetFormV2TestId = {}));
export var LayoutTestId;
(function (LayoutTestId) {
    LayoutTestId["LogoContainer"] = "LogoContainer";
    LayoutTestId["MainContentLayout"] = "MainContentLayout";
})(LayoutTestId || (LayoutTestId = {}));
export var GroupsSelectorTestId;
(function (GroupsSelectorTestId) {
    GroupsSelectorTestId["AllMembers"] = "AllMembers";
    GroupsSelectorTestId["SpecificGroups"] = "SpecificGroups";
})(GroupsSelectorTestId || (GroupsSelectorTestId = {}));
export var DatesSelectorTestId;
(function (DatesSelectorTestId) {
    DatesSelectorTestId["BudgetActiveDate"] = "BudgetActiveDate";
})(DatesSelectorTestId || (DatesSelectorTestId = {}));
export var BudgetFormContainerTestId;
(function (BudgetFormContainerTestId) {
    BudgetFormContainerTestId["BudgetName"] = "BudgetName";
    BudgetFormContainerTestId["BudgetUnitAmount"] = "BudgetUnitAmount";
})(BudgetFormContainerTestId || (BudgetFormContainerTestId = {}));
export var GroupOrderEntryTestId;
(function (GroupOrderEntryTestId) {
    GroupOrderEntryTestId["CartCheckoutButton"] = "CartCheckoutButton";
    GroupOrderEntryTestId["DeleteCartButton"] = "DeleteCartButton";
    GroupOrderEntryTestId["TrackOrderButton"] = "TrackOrderButton";
    GroupOrderEntryTestId["ViewReceiptButton"] = "ViewReceiptButton";
    GroupOrderEntryTestId["JoinGroupCartButton"] = "JoinGroupCartButton";
})(GroupOrderEntryTestId || (GroupOrderEntryTestId = {}));
export var AddedStoresPanelTestId;
(function (AddedStoresPanelTestId) {
    AddedStoresPanelTestId["ShowSpendingLimitToggle"] = "ShowSpendingLimitToggle";
    AddedStoresPanelTestId["SelectRegularGoCartRadioToggle"] = "SelectRegularGoCartRadioToggle";
    AddedStoresPanelTestId["SelectSplitBillGoCartRadioToggle"] = "SelectSplitBillGoCartRadioToggle";
    AddedStoresPanelTestId["SpendingLimitTextField"] = "SpendingLimitTextField";
    AddedStoresPanelTestId["StartGroupOrdersButton"] = "StartGroupOrdersButton";
    AddedStoresPanelTestId["StoreCountDisplayContainer"] = "StoreCountDisplayContainer";
})(AddedStoresPanelTestId || (AddedStoresPanelTestId = {}));
export var CalendarViewTestId;
(function (CalendarViewTestId) {
    CalendarViewTestId["ShowWeekendsToggle"] = "ShowWeekendsToggle";
})(CalendarViewTestId || (CalendarViewTestId = {}));
export var AddressAutocompleteTestId;
(function (AddressAutocompleteTestId) {
    AddressAutocompleteTestId["AddressAutocompleteTextInput"] = "AddressAutocompleteTextInput";
})(AddressAutocompleteTestId || (AddressAutocompleteTestId = {}));
export var JoinByInviteTestId;
(function (JoinByInviteTestId) {
    JoinByInviteTestId["PageLoadingSpinner"] = "PageLoadingSpinner";
})(JoinByInviteTestId || (JoinByInviteTestId = {}));
export var VoucherPreviewPageTestId;
(function (VoucherPreviewPageTestId) {
    VoucherPreviewPageTestId["VoucherLoading"] = "VoucherLoading";
})(VoucherPreviewPageTestId || (VoucherPreviewPageTestId = {}));
